import PropTypes from "prop-types"
import styled from "styled-components"
import media from "@styles/media"
import { handleMobileSize } from "./helpers"
import { cssConfig } from "@utils/css-validator"

const Heading = styled.h1.withConfig(cssConfig)`
  scroll-margin: 6rem;
  color: ${props => props.color ?? props.theme.color.blue600};
  text-align: ${props => (props.center ? "center" : props.textAlign)};
  font-weight: ${props => props.fontWeight ?? "700"};
  margin: ${props => props.margin ?? "0"};
  padding: ${props => props.padding ?? "0"};
  line-height: ${props => props.lineHeight};
  max-width: ${props => props.maxWidth};
  letter-spacing: ${props => props.letterSpacing};

  ${media.sm`
    max-width: ${props => props.maxWidthSm};
    margin: ${({ marginSm }) => marginSm};
    padding: ${({ paddingSm }) => paddingSm};
    font-size: ${props =>
      handleMobileSize(
        props.fontSize ?? handleSize(props.as),
        props.mobileScale
      )};
    text-align: ${({ textAlignSm }) => textAlignSm};
  `}

  ${media.md`
    max-width: ${props => props.maxWidthMd};
    margin: ${({ marginMd }) => marginMd};
    padding: ${({ paddingMd }) => paddingMd};
    text-align: ${({ textAlignMd }) => textAlignMd};
  `}

  ${media.sm_up`
    font-size: ${props =>
      handleMobileSize(
        props.fontSize ?? handleSize(props.as),
        props.tabletScale
      )};
		padding: ${props => props.paddingMd ?? props.padding};
	`}

  ${media.md_up`
    font-size: ${props => props.fontSize ?? handleSize(props.as)};
		padding: ${props => props.padding};
  `}
`

const handleSize = size => {
  switch (size) {
    case "h1":
      return `3rem`
    case "h2":
      return `2.5rem`
    case "h3":
      return `2rem`
    case "h4":
      return `1.5rem`
    case "h5":
      return `1.3rem`
    case "h6":
      return `1.2rem`
  }
}

Heading.defaultProps = {
  as: "h1",
  mobileScale: 0.8,
  tabletScale: 0.9,
  lineHeight: "1.25",
  letterSpacing: "-.03rem",
}

Heading.propTypes = {
  as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  color: PropTypes.string,
  center: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  padding: PropTypes.string,
  paddingSm: PropTypes.string,
  paddingMd: PropTypes.string,

  margin: PropTypes.string,
  marginSm: PropTypes.string,
  marginMd: PropTypes.string,

  fontSize: PropTypes.string,
  lineHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  letterSpacing: PropTypes.string,

  maxWidth: PropTypes.string,
  maxWidthSm: PropTypes.string,
  maxWidthMd: PropTypes.string,

  tabletScale: PropTypes.number,
  mobileScale: PropTypes.number,

  textAlign: PropTypes.string,
  textAlignSm: PropTypes.string,
  textAlignMd: PropTypes.string,
}

export default Heading
